<template>
    <div class="footer-section">
        <div class="footer-container">
            <section class="footer-info">
                <div class="footer-logo">
                    <img :src="a3" alt="Efisense">
                </div>

                <p class="footer-description fuente-nova">
                    Diseñamos experiencias exepcionales para marcas lideres que buscan una
                    conexión auténtica con sus clientes.
                </p>

                <div class="footer-links">
                    <a href="https://efisense.com" target="_blank" class="fuente-nova">efisense.com</a>
                    <a href="mailto:hola@efisense.com" class="fuente-nova">hola@efisense.com</a>
                    <a href="tel:+529999306053" target="_blank" class="fuente-nova">+52 (999) 930.60.53</a>
                </div>

                <div class="footer-social">
                    <a href="https://www.facebook.com/efisense" target="_blank">
                        <img :src="a30" alt="Facebook">&nbsp;&nbsp;&nbsp;Facebook
                    </a>
                    <a href="https://www.instagram.com/efisense/" target="_blank">
                        <img :src="a29" alt="Instagram">&nbsp;&nbsp;&nbsp;Instagram
                    </a>
                    <a href="https://wa.me/529996435584" target="_blank">
                        <img :src="a47" alt="WhatsApp">&nbsp;&nbsp;&nbsp;WhatsApp
                    </a>
                </div>

                <p class="footer-address fuente-nova">
                    Efisense Media, Tablaje 33796 Calle 34 S/N, Komchén, Mérida, YUC 97302, Mexico
                </p>
            </section>

            <section class="footer-landings">
                <article v-for="section in landings" :key="section.name" class="landing-group">
                    <h2 class="fuente-nova2">{{ section.name }}</h2>
                    <p v-for="landing in section.landings" :key="landing.relativePath" class="fuente-nova" @click="pushLanding(landing)">
                        {{ landing.name }}
                    </p>
                    <template v-if="section.subs && section.subs.length > 0">
                        <article v-for="subSection in section.subs" :key="subSection.name" class="landing-group">
                            <h2 class="fuente-nova2">{{ subSection.name }}</h2>
                            <p v-for="landing in subSection.landings" :key="landing.relativePath" class="fuente-nova" @click="pushLanding(landing)">
                                {{ landing.name }}
                            </p>
                        </article>
                    </template>
                </article>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterNew',
    data() {
        return {
            a3: require('@/assets/images/a46.png'),
            a29: require('@/assets/images/a29.svg'),
            a30: require('@/assets/images/a30.svg'),
            a47: require('@/assets/images/a47.svg'),
            landings: []
        }
    },
    mounted() {
        this.getLandings()
    },
    methods: {
        getLandings() {
            const config = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            fetch('https://mikele.efisen.se/apiCRM/Landing/getList', config)
                .then(response => response.json())
                .then(data => {
                    if (data.code && data.code === 200) {
                        this.landings = data.data
                    } else {
                        this.landings = []
                        console.error('Error fetching landings:', data.message)
                    }
                })
                .catch(error => {
                    console.error('Error fetching landings:', error)
                })
        },
        pushLanding(landing) {
            this.$router.push({
                path: `/l/${landing.relativePath}`,
                state: landing
            })
        },
    },
}
</script>

<style lang="css" scoped>
.footer-section {
    width: 100vw;
    min-height: 100vh;
    background-color: #272727;
    scroll-snap-align: start;
    box-sizing: border-box;
}

.footer-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    max-width: 1800px;
    margin: 0 auto;
    padding: 80px 10px;
}

.footer-info {
    max-width: 30%;
    color: white;
}

.footer-logo {
    max-width: 300px;
}

.footer-logo img {
    width: 100%;
}

.footer-description {
    font-size: clamp(5px, 4vw, 20px);
    margin-top: 30px;
    margin-left: 20px;
    margin-right: 20px;
}

.footer-links {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.footer-links a {
    color: white;
    font-size: clamp(5px, 3vw, 12px);
    font-weight: bold;
    margin-left: 20px;
    text-decoration: none;
}

.footer-social {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 15px;
}

.footer-social a {
    color: white;
    font-weight: bold;
    margin-left: 20px;
    text-decoration: none;
    font-size: clamp(8px, 4vw, 20px);
    display: flex;
    align-items: center;
}

.footer-social img {
    width: 18px;
    height: 18px;
}

.footer-address {
    font-size: clamp(5px, 4vw, 13px);
    margin-top: 30px;
    margin-left: 20px;
    margin-right: 20px;
}

.footer-landings {
    padding-top: 135px;
    width: 65%;
    display: flex;
    flex-wrap: wrap;
}

.landing-group {
    color: white;
    max-width: 40%;
    margin: 0 20px;
}

.landing-group h2 {
    font-weight: 30px;
    font-size: clamp(8px, 5vw, 20px);
}

.landing-group p {
    color: white;
    margin-left: 30px;
    font-size: clamp(8px, 5vw, 15px);
    font-weight: bold;
    cursor: pointer;
}

.landing-group p:hover {
    color: gray;
}

/* Mobile */
@media (max-width: 768px) {
    .footer-section {
        min-height: auto;
        padding: 40px 20px;
    }

    .footer-container {
        flex-direction: column;
        padding: 20px 10px;
    }

    .footer-info {
        max-width: 100%;
        display: flex;
        flex-direction: column;
    }

    .footer-logo {
        display: none;
    }

    .footer-description {
        margin: 0 0 20px 0;
        font-size: 14px;
    }

    .footer-links {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 5px 15px;
        margin-top: 0;
    }

    .footer-links a {
        margin-left: 0;
        font-size: 12px;
    }

    .footer-social {
        flex-direction: row;
        gap: 20px;
        margin-top: 15px;
    }

    .footer-social a {
        margin-left: 0;
        font-size: 14px;
    }

    .footer-social img {
        width: 20px;
        height: 20px;
    }

    .footer-address {
        margin: 20px 0 0 0;
        font-size: 11px;
        opacity: 0.7;
    }

    .footer-landings {
        width: 100%;
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        border-top: 1px solid rgba(255,255,255,0.2);
        margin-top: 20px;
    }

    .landing-group {
        width: 50%;
        max-width: 50%;
        margin: 0;
        padding: 10px 10px 0 0;
        box-sizing: border-box;
    }

    .landing-group h2 {
        font-size: 14px;
        margin-bottom: 8px;
    }

    .landing-group p {
        font-size: 12px;
        margin-left: 0;
        font-weight: normal;
        margin-bottom: 5px;
    }
}
</style>
